import PropTypes from 'prop-types';
import Image from '~/app/components/image/image';
import { Box, Text } from '@nerdwallet/currency';
import classNames from 'classnames';
import styles from './branded-login.module.scss';
import { Auth0Buttons } from '../auth0-buttons/auth0-buttons';
import UniversalText from '../universal-text/universal-text';

const defaultAnimatedImageUrl =
  'https://www.nerdwallet.com/cdn/landing-pages/lpc/Markup-Arrow-05-Green.gif';

const BrandedLogin = ({
  onSuccess,
  isSignedIn,
  loginPageCopyOverride,
  brandedBackgroundImage,
  brandedIcon,
  brandedTitle: brandedTitleObsolete,
  brandedSubtitle: brandeSubtitleObsolete,
  customCtaText,
  topLoginBoxColor,
  bottomLoginBoxColor,
  topLoginBoxMargin,
  bottomLoginBoxMargin,
  outputAnimatedArrowAboveCta,
  animatedImageUrl,
  loginPageTitle,
  loginPageSubtitle,
}) => {
  const shouldUseObsoleteTitle = !loginPageTitle?.text;
  const shouldUseObsoleteSubtitle = !loginPageSubtitle?.text;
  return (
    <Box
      id="branded-login"
      className={styles.container}
      style={{ backgroundImage: `url(${brandedBackgroundImage})` }}
    >
      <Box
        className={styles.card}
        style={{
          borderTopColor: topLoginBoxColor || '#8a1c32',
          borderBottomColor: bottomLoginBoxColor || '#ffc627',
          marginTop: topLoginBoxMargin || 212,
          marginBottom: bottomLoginBoxMargin || 212,
        }}
      >
        {brandedIcon && (
          <Image
            className={styles.cardIcon}
            src={brandedIcon}
            alt="NerdWallet Brand"
            backgroundColor="transparent"
            naturalHeight={318}
            naturalWidth={289}
            loading="lazy"
            fetchPriority="low"
          />
        )}
        <Box className={styles.cardHeading}>
          {shouldUseObsoleteTitle && (
            <Text className={styles.cartTitle} size="large">
              {loginPageCopyOverride || brandedTitleObsolete}
            </Text>
          )}

          {loginPageTitle && <UniversalText {...loginPageTitle} />}

          {shouldUseObsoleteSubtitle && (
            <Box className={styles.cardSubtitle}>
              <Text component="p">{brandeSubtitleObsolete}</Text>
            </Box>
          )}

          {loginPageSubtitle && (
            <UniversalText
              {...loginPageSubtitle}
              defaultOptions={{ text: { textType: 'text' } }}
            />
          )}
        </Box>
        {!isSignedIn ? (
          <div style={{ position: 'relative' }}>
            {outputAnimatedArrowAboveCta && (
              <Image
                className={classNames([
                  styles.animatedIcon,
                  { [styles.animatedIconDefault]: !animatedImageUrl },
                ])}
                src={animatedImageUrl || defaultAnimatedImageUrl}
                alt="Cta arrow icon"
                backgroundColor="transparent"
                naturalHeight={400}
                naturalWidth={400}
              />
            )}
            <Auth0Buttons.Container>
              <Auth0Buttons.GenericButton
                redirectTo={onSuccess}
                customCtaText={customCtaText}
                buttonStyle={{ secondary: true }}
              />
            </Auth0Buttons.Container>
          </div>
        ) : null}
      </Box>
    </Box>
  );
};

BrandedLogin.displayName = 'Branded Login';

BrandedLogin.propTypes = {
  onSuccess: PropTypes.string,
  isSignedIn: PropTypes.bool,
  loginPageCopyOverride: PropTypes.string,
  brandedBackgroundImage: PropTypes.string,
  brandedIcon: PropTypes.string,
  brandedTitle: PropTypes.string,
  brandedSubtitle: PropTypes.string,
  customCtaText: PropTypes.string,
  topLoginBoxColor: PropTypes.string,
  bottomLoginBoxColor: PropTypes.string,
  topLoginBoxMargin: PropTypes.number,
  bottomLoginBoxMargin: PropTypes.number,
  outputAnimatedArrowAboveCta: PropTypes.bool,
  animatedImageUrl: PropTypes.string,
  loginPageTitle: PropTypes.object,
  loginPageSubtitle: PropTypes.object,
};

export default BrandedLogin;
